import { Injectable } from '@angular/core';
import { InfoMessageModel } from 'src/models/info-message/infoMessage.model';
import { Subject } from 'rxjs';
import { InfoMessageSeverity } from '@shared/enums/infoMessageSeverity';

@Injectable({
	providedIn: 'root'
})
export class InfoMessageService {
	subject: Subject<InfoMessageModel> = new Subject();

	constructor() {
	}

	addMessage(msg: InfoMessageModel): void {
		this.subject.next(msg);
	}

	createMessage(completeMessage: string, title: string = '', severity?: InfoMessageSeverity): void {
		this.addMessage({
			title,
			completeMessage,
			date: new Date(),
			severity: severity || 0
		});
	}

	addServerError(error?: any): void {
		if (error && error.message) {
			this.createMessage(error.message, 'Fehler', InfoMessageSeverity.danger);
			return;
		}

		this.createMessage(
			`Laden Sie bitte die Seite neu.
			Wenn es weiterhin nicht funktionieren sollte, wenden Sie sich bitte an einen Administrator.`,
			'Serverfehler!',
			InfoMessageSeverity.danger
		);
	}

	addServerMessage(msg: any): void {
		let body: any;
		try {
			body = JSON.parse(msg._body);
		} catch (e) {
			this.addServerError(msg.error);
			return;
		}
		if (body.message === undefined) {
			this.addServerError();
		} else {
			this.createMessage(msg.error.message, msg.status, InfoMessageSeverity.warning);
		}
	}
}
